import script from "./Guide.vue?vue&type=script&setup=true&lang=js"
export * from "./Guide.vue?vue&type=script&setup=true&lang=js"

import "./Guide.vue?vue&type=style&index=0&id=fde60630&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde60630"]])

export default __exports__